import ValidationMethod from './ValidationMethod';

const maxLength = ({ max = 0, errorMessage = '' } = {}): ValidationMethod => (v) => (v && v?.length < max) || errorMessage;

export { maxLength };
export default maxLength;
